import activityPageSlice from "../components/activity-page/store/slice";
import bookingFilterSlice from "../components/booking-filters/store/slice";
import bookingFormSlice from "../components/booking-form/store/slice";
import bookingPageSlice from "../components/booking-page/store/slice";
import bookingPricingSlice from "../components/booking-pricing/store/slice";
import bookingSearchSlice from "../components/booking-search/store/slice";
import bookingSettingSlice from "../components/booking-settings/store/slice";
import bookingShowSlice from "../components/booking-show/store/slice";
import cargoTypeSlice from "../components/cargo-types/store/slice";
import changePasswordPageSlice from "../components/change-password-page/store/slice";
import companySlice from "../components/companies/store/slice";
import companyPageSlice from "../components/company-page/store/slice";
import countrySlice from "../components/countries/store/slice";
import documentSlice from "../components/documents/store/slice";
import registerPageSlice from "../components/register-page/store/slice";
import forgotPasswordPageSlice from "../components/forgot-password-page/store/slice";
import invitationPageSlice from "../components/invitation-page/store/slice";
import loginPageSlice from "../components/login-page/store/slice";
import maintenanceCoverSlice from "../components/maintenance-cover/store/slice";
import resetPasswordPageSlice from "../components/reset-password-page/store/slice";
import roleSlice from "../components/roles/store/slice";
import routeSlice from "../components/routes/store/slice";
import statusSlice from "../components/statuses/store/slice";
import { toasterSlice } from "../components/toaster/store/slice";
import updateBarSlice from "../components/update-bar/store/slice";
import userFiltersSlice from "../components/user-filters/store/slice";
import userPageSlice from "../components/user-page/store/slice";
import userSlice from "../components/users/store/slice";
import vehicleTypeSlice from "../components/vehicle-types/store/slice";
import profilePageSlice from "../components/profile-page/store/slice";
import trailerTypeSlice from "../components/trailer-types/store/slice";

const rootReducer = {
  // Pages
  loginPage: loginPageSlice.reducer,
  forgotPasswordPage: forgotPasswordPageSlice.reducer,
  registerPage: registerPageSlice.reducer,
  resetPasswordPage: resetPasswordPageSlice.reducer,
  changePasswordPage: changePasswordPageSlice.reducer,
  activityPage: activityPageSlice.reducer,
  bookingPage: bookingPageSlice.reducer,
  invitationPage: invitationPageSlice.reducer,
  companyPage: companyPageSlice.reducer,
  userPage: userPageSlice.reducer,
  profilePage: profilePageSlice.reducer,

  // Components
  bookingFilters: bookingFilterSlice.reducer,
  bookingSettings: bookingSettingSlice.reducer,
  bookingSearch: bookingSearchSlice.reducer,
  bookingPricing: bookingPricingSlice.reducer,
  bookingForm: bookingFormSlice.reducer,
  bookingShow: bookingShowSlice.reducer,
  toaster: toasterSlice.reducer,
  updateBar: updateBarSlice.reducer,
  maintenanceCover: maintenanceCoverSlice.reducer,
  routes: routeSlice.reducer,
  statuses: statusSlice.reducer,
  vehicleTypes: vehicleTypeSlice.reducer,
  trailerTypes: trailerTypeSlice.reducer,
  roles: roleSlice.reducer,
  companies: companySlice.reducer,
  cargoTypes: cargoTypeSlice.reducer,
  countries: countrySlice.reducer,
  users: userSlice.reducer,
  documents: documentSlice.reducer,
  userFilters: userFiltersSlice.reducer,
};

export default rootReducer;
